import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export const afterLogoutApi = createApi({
  reducerPath: "afterLogoutApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_BFF_WEB_URL,
    credentials: "include"
  }),
  endpoints: (build) => ({
    postAfterLogout: build.mutation<void, void>({
      query: () => ({
        url: "Account/after-logout",
        method: "POST",
      }),
    }),
  }),
});

export const { usePostAfterLogoutMutation } = afterLogoutApi;
